import { useMutation, useQueryClient } from '@tanstack/react-query';
import api from '../../http';
import { useForBindingId } from '../../../forBinding';
import { getApiErrorMessage, toApiError } from '../utils';

export function useDeleteProperty() {
    const queryClient = useQueryClient();
    const forBinding = useForBindingId();

    return useMutation({
        mutationFn: async (id: string) => {
            try {
                return (await api.delete(`/user/prop/delete/${id}`, {
                    params: { forBinding },
                })).data;
            } catch (error) {
                throw toApiError(error, 'Erro ao deletar propriedade');
            }
        },
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ['properties'] })
        },
        onError: error => console.error('Erro ao deletar propriedade:', getApiErrorMessage(error, 'Erro ao deletar propriedade')),
    });
}
